import {
    deleteItemById,
    fetchAllItems,
    fetchAllItemsByCategory, fetchCategories,
    fetchItemById,
    saveItem,
    updateItem
} from '@/api/item.api'
import Vue from 'vue'

const state = {
    fetchingItems: true,
    items: [],
    itemPageInfo: {
        currentPage: 0,
        pageSize: 12
    },
    categories: []
}

const getters = {
    isFetchingItems: state => state.fetchingItems,

    getItems: state => state.items,

    getItemById: state => itemId => state.items.find(i => i.id === itemId),

    getItemPageInfo: state => state.itemPageInfo,

    getCategories: state => state.categories
}

const actions = {
    async deleteItemById({ dispatch, state }, existingId) {
        await deleteItemById(existingId)
        dispatch('pageItems', { page: state.itemPageInfo.currentPage, pageSize: state.itemPageInfo.pageSize })
    },

    async saveItem({ dispatch, state }, request) {
        await saveItem(request)
            .then(() => {
                Vue.notify({
                    group: 'success',
                    text: 'Proizvod je uspesno sacuvan'
                })
                dispatch('pageItems', { page: state.itemPageInfo.currentPage, pageSize: state.itemPageInfo.pageSize })
            })
            .catch(() => {
                Vue.notify({
                    group: 'errors',
                    title: 'Greška na serveru',
                    text: 'Doslo je do greske na serveru, molimo vas pokusajte kasnije'
                })
            })
    },

    async updateItem({ commit }, { request, existingId }) {
        await updateItem(request, existingId)
            .then(response => {
                Vue.notify({
                    group: 'success',
                    text: 'Proizvod je uspesno promenjen'
                })
                commit('updateItem', response.data)
            })
            .catch(() => {
                Vue.notify({
                    group: 'errors',
                    title: 'Greška na serveru',
                    text: 'Doslo je do greške na serveru, molimo Vas pokušajte kasnije'
                })
            })
    },

    async pageItems({ commit }, { page, pageSize }) {
        commit('setFetchingItems', true)
        const response = await fetchAllItems(page, pageSize)
        const items = response.data.content
        const sortedItems = items.sort(
            (a, b) => (a.itemIndex > b.itemIndex) ? 1 : ((a.itemIndex < b.itemIndex) ? -1 : 0)
        )
        commit('setItems', sortedItems)
        commit('setItemPageInfo', {
            currentPage: response.data.number,
            totalPages: response.data.totalPages,
            numberOfElements: response.data.numberOfElements,
            totalElements: response.data.totalElements,
            pageSize: response.data.size,
            isFirstPage: response.data.first,
            isLastPage: response.data.last
        })
        commit('setFetchingItems', false)
    },

    async pageItemsByCategory({ commit }, { page, pageSize, category }) {
        commit('setFetchingItems', true)
        const response = await fetchAllItemsByCategory(page, pageSize, category)
        const items = response.data.content
        const sortedItems = items.sort(
            (a, b) => (a.itemIndex > b.itemIndex) ? 1 : ((a.itemIndex < b.itemIndex) ? -1 : 0)
        )
        commit('setItems', sortedItems)
        commit('setItemPageInfo', {
            currentPage: response.data.number,
            totalPages: response.data.totalPages,
            numberOfElements: response.data.numberOfElements,
            totalElements: response.data.totalElements,
            pageSize: response.data.size,
            isFirstPage: response.data.first,
            isLastPage: response.data.last
        })
        commit('setFetchingItems', false)
    },

    async fetchItemById({ commit }, id) {
        const response = await fetchItemById(id)
        commit('updateItem', response.data)
    },

    async fetchCategories({ commit }) {
        const response = await fetchCategories()
        commit('setCategories', response.data)
    }
}

const mutations = {
    setFetchingItems: (state, fetchingItems) => state.fetchingItems = fetchingItems,

    updateItem: (state, item) => {
        if (state.items.length === 0) {
            state.items.push(item)
        }
        else {
            const index = state.items.findIndex(i => i.id === item.id)
            if (index !== -1)
                state.items.splice(index, 1, item)
        }
    },

    setItems: (state, items) => {
        state.items = items
    },

    setItemPageInfo: (state, itemPageInfo) => {
        state.itemPageInfo = itemPageInfo
    },

    setCategories: (state, categories) => {
        state.categories = categories
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}
